// report.translation.mixin.js

export default {
    data () {
        return {}
    },
    computed: {},
    watch: {},
    created () {},
    methods: {
        async getCompanyReviews (project_code, campaign_id, company_id) {
            try {
                const _res_review_data = await this.$axios.get('/evaluation', {
                    params: {
                        project_code: project_code,
                        campaign_id: campaign_id,
                        company_id: company_id,
                    }
                })
                return _res_review_data.data
            } catch (error) {
                throw new Error(`review 데이터 요청 에러: ${company_id}`)
            }
        },
        async translateEvaluationReview (project_code, campaign_id, company_id, overwrite = true, reviews) {
            try {
                if (reviews || !overwrite) {
                    if (!reviews) {
                        throw new Error('No Reviews')
                    }

                    const _translation_sub_codes = reviews.filter(({ item }) => (
                        item.review_comment && (!item.review_comment_ca || !item.review_comment_ea)
                        ||
                        item.comment && (!item.comment_ca || !item.comment_ea)
                    ))
    
                    if (_translation_sub_codes && _translation_sub_codes.length) {
                        const _review_translate_request = _translation_sub_codes.map(sub_code_review => 
                            this.$axios.put(
                                sub_code_review.type === "review" ? '/evaluation/translate/review' : '/evaluation/translate/ev-result',
                                {
                                    project_code: project_code,
                                    campaign_id: campaign_id,
                                    company_id: company_id,
                                    sub_code: sub_code_review.sub_code,
                                    overwrite: overwrite ? 1 : 0
                                }
                            )
                        )
    
                        await Promise.all(_review_translate_request)
                    }   
                } else {
                    await Promise.all([
                        this.$axios.put('/evaluation/translate/review',
                            { project_code, campaign_id, company_id, overwrite: overwrite }
                        ),
                        this.$axios.put('/evaluation/translate/ev-result',
                            { project_code, campaign_id, company_id, overwrite: overwrite }
                        )
                    ])
                }
            } catch (error) {
                console.log(error)
                // alert(`변역 도중 에러 발생: ${company_id}`)
                throw new Error(`변역 도중 에러 발생: ${company_id}`)
            }
        },
    }
}